import { featureFlagsQuerySchema, featureFlagsResponseSchema, } from '../contracts/feature-flags';
import { parseSchema } from '../errors';
/**
 * Fetch feature flags by key list.
 *
 * Pass `organizationId` to have the backend evaluate the flags for that
 * organization rather than for the caller alone; the caller must be a member
 * of it.
 */
export async function getFeatureFlags(client, flagKeys, organizationId) {
    const validatedQuery = parseSchema(featureFlagsQuerySchema, {
        flagKeys,
        ...(organizationId ? { organizationId } : {}),
    });
    const response = await client.get('/feature-flags', {
        params: validatedQuery,
    });
    return parseSchema(featureFlagsResponseSchema, response);
}
//# sourceMappingURL=feature-flags.js.map